

const styles = {
    cardSpan: {
        background: "#1f8bf3",
        padding: '6px 20px',
        color: '#fff',
        fontSize: '14px',
        textTransform: 'uppercase',
        letterSpaceing: '1px',
    },
    cardSpan2: {
        background: "#edad13",
        padding: '6px 20px',
        color: '#fff',
        fontSize: '14px',
        textTransform: 'uppercase',
        letterSpaceing: '1px',
    },
    star: {
        padding: "5px", color: '#edad13', fontSize: '18px',
    },
    dFlex: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    heartIcon: {
        color: '#ff6464', fontSize: '18px'
    },
    cardImage: {
        display: 'flex', justifyContent: 'center', alignItems: 'center',padding: '10px', margin: '30px 0', width: '95%',
        height: '200px'
    },
    separator: {
        height: '0.007rem', border: "none", background: 'lightgray'
    },
    price: {
        color: '#1f8bf3', fontSize: '18px', fontWeight: "400", marginTop: '20px', fontWeight: '600'
    },
    price2: {
        fontSize: '25px', fontWeight: "400", marginTop: '20px', fontWeight: "600"
    },
    cardBtn: {
        textTransform: "uppercase", letterSpacing: '1px', background: "#1f8bf3", padding: "10px 30px 35px 30px", fontWeight: "600"
    },
    wishList: {
        fontSize: '18px', paddingRight: '5px'
    },
    cardHeading: {
        fontWeight: '400', letterSpacing: '1px', textTransform: 'uppercase', marginTop: '20px'
    }
}

export default styles;